import { CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';

export class CommuterTrafficTypeService {
   async getCommuterTrafficTypes(query?: LocationQuery) {
      return await http.get('/commuter-traffic-types', { params: { ...query } }).then((response: any) => {
         return response.data;
      });
   }
   async getContractCommuterTrafficTypes(query?: LocationQuery) {
      return await http
         .get('/contract-commuter-traffic-types', { params: { ...query }, cancelable: false } as CustomAxiosRequestConfig)
         .then((response: any) => {
            return response.data;
         });
   }
}
